import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const CloseIcon = forwardRef(
  ({ color: rawColor = "currentColor", size: sizeFromProps, style, ...props }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    return /* @__PURE__ */ jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        ref: forwardedRef,
        style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
        children: [
          isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: color,
              d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm3.53-5.47a.75.75 0 0 1-1.06 0L12 13.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 1.06-1.06L12 10.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L13.06 12l2.47 2.47a.75.75 0 0 1 0 1.06Z",
              fillRule: "evenodd",
              clipRule: "evenodd"
            }
          )
        ]
      }
    );
  }
);

export { CloseIcon };
//# sourceMappingURL=CloseIcon.mjs.map
